// Brücke zwischen Seite und Service-Worker-Caches (public/sw.js).
// Der SW cacht GET /api/*-Antworten für den Offline-Start — die sind PERSONENBEZOGEN (Session).
// Deshalb wird der API-Cache bei jedem Kontowechsel geleert: Login UND Logout. So zeigt ein
// geteiltes Gerät offline nie den Datenstand eines anderen Kontos (Privacy by Design, CLAUDE.md).

/** Muss zum API_CACHE-Namen in public/sw.js passen. */
const API_CACHE = 'wf-api-v1'

/** Gecachte API-Antworten verwerfen (fire-and-forget; ohne SW/CacheStorage ein No-op). */
export function clearApiCache(): void {
  try {
    if (typeof caches !== 'undefined') void caches.delete(API_CACHE)
  } catch {
    // CacheStorage nicht verfügbar (alter Browser, Private-Mode) — dann wurde auch nichts gecacht.
  }
}
